<template>
  <div v-if="$apollo.loading">
    <spinner />
  </div>
  <div v-else class="wrapper">
    <v-flex class="title-screen" xs12>
      <span>{{ adminText('workflowsAll.visitor_statistics_d28c229', 'Visitor statistics') }}</span>
    </v-flex>
    <p id="page-description">{{ adminText('workflowsAll.data_driven_from_google_analytics_7842570', '*data driven from Google Analytics') }}</p>
    <div class="graphs-container">
      <div class="first-row">
        <visitors-total-number
          :event-id="event.id"
          :initial-date-range-option="initialDateRangeOption"
          :initial-date-range="[startDate, endDate]"
        />
        <visitors-by-age-and-gender
          :event-id="event.id"
          :initial-date-range-option="initialDateRangeOption"
          :initial-date-range="[startDate, endDate]"
        />
      </div>
      <div class="second-row">
        <visitor-by-city-stats
          :event-id="event.id"
          :initial-date-range-option="initialDateRangeOption"
          :initial-date-range="[startDate, endDate]"
        />
        <visitors-by-source
          :event-id="event.id"
          :initial-date-range-option="initialDateRangeOption"
          :initial-date-range="[startDate, endDate]"
        />
      </div>
    </div>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import VisitorByCityStats from './visitor-by-city-stats.vue'
import VisitorsBySource from './visitors-by-source.vue'
import VisitorsTotalNumber from './visitors-total-number.vue'
import VisitorsByAgeAndGender from './visitors-by-age-and-gender.vue'
import moment from 'moment'

import { GET_EVENT_SETTINGS } from '../../../graphql/event.graphql'

export default {
  mixins: [WorkflowDisplay],
  name: 'visitor-stats-container',
  components: {
    VisitorByCityStats,
    VisitorsBySource,
    VisitorsTotalNumber,
    VisitorsByAgeAndGender,
  },
  props: {
    eventId: String,
    user: Object,
  },
  data() {
    return {
      event: null,
      initialDateRangeOption: null,
      endDate: null,
      startDate: null,
    }
  },
  apollo: {
    getEvent: {
      query: GET_EVENT_SETTINGS,
      variables() {
        return {
          id: this.eventId,
        }
      },
      async result({ loading, data }) {
        if (!loading && data) {
          const { getEvent: event } = data
          this.event = event

          const eventHasEndedMoreThanWeekAgo = moment(this.event.to)
            .add(1, 'week')
            .isBefore(new Date())
          this.initialDateRangeOption = eventHasEndedMoreThanWeekAgo ? 3 : 1
          this.endDate = eventHasEndedMoreThanWeekAgo
            ? moment(this.event.to).add(1, 'week').format('YYYY-MM-DD')
            : moment(new Date()).format('YYYY-MM-DD')
          this.startDate = eventHasEndedMoreThanWeekAgo
            ? moment(this.event.from).subtract(1, 'week').format('YYYY-MM-DD')
            : moment(new Date()).subtract(1, 'week').format('YYYY-MM-DD')
        }
      },
    },
  },
}
</script>

<style scoped>
#page-description {
  font-family: 'Source Sans Pro';
  margin: 1rem 0;
  font-size: 1rem;
  color: #979797;
}
.title-screen {
  margin-bottom: 0;
}
.graphs-container {
  display: flex;
  flex-direction: column;
}
.first-row {
  display: flex;
  flex-direction: row;
  margin-bottom: 76px;
}
.first-row div:first-child {
  margin-right: 30px;
}
.second-row {
  display: flex;
  flex-direction: row;
}
.second-row div:first-child {
  margin-right: 30px;
}

@media only screen and (max-width: 1415px) {
  .first-row {
    flex-direction: column;
  }
  .second-row {
    flex-direction: column;
  }
  .first-row {
    margin-bottom: 32px;
  }

  .first-row div:first-child {
    margin-right: 0px;
    margin-bottom: 32px;
  }

  .second-row div:first-child {
    margin-right: 0px;
    margin-bottom: 32px;
  }
}

@media only screen and (max-width: 800px) {
  .first-row {
    flex-direction: column;
  }
  .second-row {
    flex-direction: column;
  }
  .first-row {
    margin-bottom: 32px;
  }

  .first-row div:first-child {
    margin-right: 0px;
    margin-bottom: 32px;
  }

  .second-row div:first-child {
    margin-right: 0px;
    margin-bottom: 32px;
  }
  .graphs-container {
    align-items: center;
  }
}
@media screen and (max-width: 800px) {
  .wrapper {
    margin-top: 1.5rem;
  }
}
</style>
